import React from "react";
import TaskItem, { TaskDetail } from "./TaskItem";
import { BaseTask } from "model/activitiesModel";
import { Monitor } from "hooks/useMonitor";

export interface StartedProcess extends TaskDetail {
  jsontag: string | null;
  idprocess: number;
  process_description: string;
  process_enddate: string | null;
  process_startdate: string | null;
  process_idprocessmodel: number;
  process_userdata: string;
  processduration: number;
}

interface ProcessItemProps {
  handleClick: (task: TaskDetail, type: "delete" | "terminate" | "disclose" | "reschedule") => void;
  process: StartedProcess;
  filters: Record<string, any>;
  setSelectedTask: (task: BaseTask) => void;
  userDataKeys: string[];
  monitors: Monitor[];
  isMonitorsLoading: boolean;
  // expandedCells: Record<string, boolean>;
  // toggleExpand: (key: string, e: React.MouseEvent) => void;
  openFullContentDialog: (content: string, title: string) => void;
}
const ProcessItem: React.FC<ProcessItemProps> = React.memo(({
  handleClick,
  setSelectedTask,
  process,
  filters,
  monitors,
  userDataKeys,
  isMonitorsLoading,
  // expandedCells,
  // toggleExpand,
  openFullContentDialog,
}) => {
  return (
    <React.Fragment>
       <TaskItem
         setSelectedTask={setSelectedTask}
         handleClick={handleClick}
         key={`task-in-processes-${process.idprocesstoken}`}
         process={process}
         monitors={monitors}
         filters={filters}
         isMonitorsLoading={isMonitorsLoading}
         task={process}
         userDataKeys={userDataKeys}
        //  expandedCells={expandedCells}
        //  toggleExpand={toggleExpand}
         openFullContentDialog={openFullContentDialog}
       />
    </React.Fragment>
  );
});

export default ProcessItem;
